export function initAlert(container = document) {
  container.querySelectorAll('.alert__close').forEach(btn => {
    if (btn.dataset.alertListener) return; // évite doublons
    btn.dataset.alertListener = 'true';

    btn.addEventListener('click', () => {
      const alert = btn.closest('.alert');
      if (!alert) return;

      alert.classList.add('alert--hide');
      const duration = 200; // fixe à 200 ms pour matcher le CSS
      setTimeout(() => {
        alert.style.display = 'none';
      }, duration);
    });
  });
}